import React, { useState } from 'react';
import {
  Box,
  Button,
  Grid,
  TextField,
  Typography,
  IconButton,
  Paper,
  InputAdornment,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from '@mui/material';
import {
  Visibility,
  VisibilityOff,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import Navbar from '../Navbar';

const AuthPage = () => {
  const [isSignup, setIsSignup] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false); // ✅ new state
  const [loginType, setLoginType] = useState('user'); 
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    confirmPassword: '',
  });

  const handleToggle = () => {
    setIsSignup(!isSignup);
    setFormData({ username: '', email: '', password: '', confirmPassword: '' });
    setShowPassword(false);
    setShowConfirmPassword(false); // ✅ reset confirm password visibility
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const endpoint = isSignup
      ? 'signup'
      : loginType === 'user'
        ? 'signin'
        : 'login';

    if (!formData.username || !formData.password || (isSignup && !formData.confirmPassword)) {
      alert('Please fill in all fields');
      return;
    }

    if (isSignup && formData.password !== formData.confirmPassword) {
      alert('Passwords do not match');
      return;
    }

    try {
      const apiUrl =
        loginType === 'user'
          ? `https://reviewhub-lc.onrender.com/api/auth/${endpoint}`
          : `https://reviewhub-lc.onrender.com/api/resellers/${endpoint}`;

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(
          isSignup
            ? { username: formData.username, email: formData.email, password: formData.password }
            : loginType === 'user'
              ? { username: formData.username, password: formData.password }
              : { resellerId: formData.username, password: formData.password }
        ),
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.message || 'Something went wrong');

      if (!isSignup) {
        localStorage.setItem('isLoggedIn', 'true');
        localStorage.setItem('username', formData.username);
        localStorage.setItem('loginType', loginType);

        if (loginType === 'reseller') {
          localStorage.setItem('resellerName', data.reseller.name);
          localStorage.setItem('resellerImage', data.reseller.profileImageUrl || '');
          localStorage.setItem('resellerId', data.reseller.resellerId);
        }

        alert('Login successful');
        navigate('/shop');
      } else {
        alert('Signup successful. Please log in.');
        setIsSignup(false);
      }

      setFormData({
        username: '',
        email: '',
        password: '',
        confirmPassword: '',
      });
    } catch (err) {
      alert(err.message);
    }
  };
const fieldStyle = {
  width: '100%',
  '& .MuiOutlinedInput-root': {
    height: 56,
    '& fieldset': {
      borderColor: '#FF758C',
    },
    '&:hover fieldset': {
      borderColor: '#FF758C',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#FF758C',
    },
  },
  '& .MuiInputLabel-root': {
    color: '#FF758C',
  },
  '& .MuiSvgIcon-root': {
    color: '#FF758C',
    right: '8px',
    position: 'absolute',
  },
  '& .MuiSelect-select': {
    paddingRight: '40px', // match space for eye icon
  },
};



  return (
    <>
      <Box
        sx={{
          height: '100vh',
          background: 'linear-gradient(to right, #FFE6E8, #FFC0CB)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: 2,
        }}
      >
        <Paper
          elevation={10}
          sx={{
            display: 'flex',
                flexDirection: { xs: 'column', md: 'row' }, // ✅ mobile = column, desktop = row
            borderRadius: 4,
            overflow: 'hidden',
            maxWidth: 700,
            width: '100%',
            minHeight: 400,
          }}
        >
          {/* Left Panel */}
          <Box
            sx={{
                 width: { xs: '80%', md: '43%' }, // ✅ full width on mobile
              background: 'linear-gradient(to bottom right, #FF758C, #FF7EB3)',
              color: '#fff',
              p: 4,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Typography variant="h5" fontWeight="bold" mb={1}>
              {isSignup ? 'Welcome Back!' : 'Hello, Friend!'}
            </Typography>
            <Typography textAlign="center" mb={3}>
              {isSignup
                ? 'To keep connected with us, please login with your credentials'
                : 'Enter your details and start your journey with us'}
            </Typography>
            <Button
              variant="outlined"
              sx={{ 
                color: '#fff', 
                borderColor: '#fff', 
                borderRadius: 3,
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.2)',
                  borderColor: '#fff'
                }
              }}
              onClick={handleToggle}
            >
              {isSignup ? 'SIGN IN' : 'SIGN UP'}
            </Button>
          </Box>

          {/* Right Panel */}
          <Box
            sx={{
               width: { xs: '100%', md: '57%' }, // ✅ full width on mobile
              p: 4,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              backgroundColor: '#fff'
            }}
          >
            <Typography variant="h5" fontWeight="bold" mb={2} color="#FF758C">
              {isSignup ? 'Create Account' : 'Sign In'}
            </Typography>

            {/* Login Type Selector */}
       {!isSignup && (
  <FormControl fullWidth sx={{ ...fieldStyle, mb: 2,width: "275px" }}>
    <InputLabel id="login-type-label">Login as</InputLabel>
    <Select
      labelId="login-type-label"
      value={loginType}
      onChange={e => setLoginType(e.target.value)}
      label="Login as"
    >
      <MenuItem value="user">User</MenuItem>
      <MenuItem value="reseller">Reseller</MenuItem>
    </Select>
  </FormControl>
)}

            <form onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                {/* Username Field */}
                <Grid item xs={12}>
<TextField
  label="Username"
  variant="outlined"
  name="username"
  value={formData.username}
  onChange={handleChange}
  sx={{ ...fieldStyle, width: "275px" }}   // set your desired width
/>

                </Grid>

                {/* Email Field - Signup Only */}
                {isSignup && (
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Email"
                      name="email"
                      type="email"
                      variant="outlined"
                      value={formData.email}
                      onChange={handleChange}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': { borderColor: '#FF758C' },
                          '&:hover fieldset': { borderColor: '#FF758C' },
                        },
                        '& .MuiInputLabel-root': {
                          color: '#FF758C',
                        },width: "275px"
                      }}
                    />
                  </Grid>
                )}

                {/* Password Field */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Password"
                    name="password"
                    type={showPassword ? 'text' : 'password'}
                    variant="outlined"
                    value={formData.password}
                    onChange={handleChange}
                    sx={{ 
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                          borderColor: '#FF758C',
                        },
                        '&:hover fieldset': {
                          borderColor: '#FF758C',
                        },
                      },
                      '& .MuiInputLabel-root': {
                        color: '#FF758C',
                      },
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton 
                            onClick={() => setShowPassword(prev => !prev)}
                            sx={{ color: '#FF758C' }}
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                {/* Confirm Password - Signup Only */}
                {isSignup && (
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Confirm Password"
                      name="confirmPassword"
                      type={showConfirmPassword ? 'text' : 'password'} // ✅ toggle type
                      variant="outlined"
                      value={formData.confirmPassword}
                      onChange={handleChange}
                      sx={{ 
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': {
                            borderColor: '#FF758C',
                          },
                          '&:hover fieldset': {
                            borderColor: '#FF758C',
                          },
                        },
                        '& .MuiInputLabel-root': {
                          color: '#FF758C',
                        },
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton 
                              onClick={() => setShowConfirmPassword(prev => !prev)}
                              sx={{ color: '#FF758C' }}
                            >
                              {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                )}

                {/* Submit Button */}
                <Grid item xs={12}>
                  <Button
                    type="submit"
                    variant="contained"
                    fullWidth
                    sx={{
                      backgroundColor: '#FF758C',
                      py: 1.5,
                      fontWeight: 'bold',
                      borderRadius: 3,
                      '&:hover': {
                        backgroundColor: '#FF5A7F',
                      },
                    }}
                  >
                    {isSignup ? 'SIGN UP' : 'SIGN IN'}
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Box>
        </Paper>
      </Box>
    </>
  );
};

export default AuthPage;